import { handleResponse, handleError } from "./apiUtils";
import config from "../config";
//const baseUrl = "/api";
//const getleadMasterUrl = "/getleadmasterdata";

export function getleadMaster() {
  const masterDataUrl = config.GetLeadMasterData_URL;
  return fetch(masterDataUrl) //fetch(baseUrl + getleadMasterUrl)
    .then(handleResponse)
    .catch(handleError);
}
export function getOffLineMaster() {
  return {
    ProductMaster: [
      {
        BussinessUnit: "CIP",
        En: {
          Product: [
            {
              id: "5e7e2597-2fb4-ea11-a812-000d3a852c27",
              Name: "Paper Packaging",
              Product: [
                {
                  id: "1a9ecc40-25e9-ea11-a817-000d3a85408a",
                  Name: "Corrugated Shipper",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "24cf9e59-25e9-ea11-a817-000d3a85408a",
                  Name: "Non Corrugated Shipper",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "5017368b-25e9-ea11-a817-000d3a85408a",
                  Name: "Paper Pallet",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "804eedaf-25e9-ea11-a817-000d3a85408a",
                  Name: "Paper Pad",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "4fde31d0-25e9-ea11-a817-000d3a85408a",
                  Name: "Honeycomb Corrugated Shipper",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "d9b022ed-25e9-ea11-a817-000d3a85408a",
                  Name: "Corner Flap Cushion",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "f69a2305-26e9-ea11-a817-000d3a85408a",
                  Name:
                    "Packing Accessories: Adhesive Tape, Bubble Wrap, Strap",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "360892ce-2fb4-ea11-a812-000d3a852c27",
              Name: "Marketing and Event Products",
              Product: [
                {
                  id: "fd108aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Merchandise Display Packaging",
                  Product: [],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
        Th: {
          Product: [
            {
              id: "5e7e2597-2fb4-ea11-a812-000d3a852c27",
              Name: "บรรจุภัณฑ์กระดาษ",
              Product: [
                {
                  id: "1a9ecc40-25e9-ea11-a817-000d3a85408a",
                  Name: "กล่องกระดาษมีลอน",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "24cf9e59-25e9-ea11-a817-000d3a85408a",
                  Name: "กล่องกระดาษไม่มีลอน",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "5017368b-25e9-ea11-a817-000d3a85408a",
                  Name: "พาเลทกระดาษ",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "804eedaf-25e9-ea11-a817-000d3a85408a",
                  Name: "แผ่นรองกระดาษ",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "4fde31d0-25e9-ea11-a817-000d3a85408a",
                  Name: "กล่องกระดาษแบบ Honeycomb",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "d9b022ed-25e9-ea11-a817-000d3a85408a",
                  Name: "กระดาษอัดมุมฉาก",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
                {
                  id: "f69a2305-26e9-ea11-a817-000d3a85408a",
                  Name: "อุปกรณ์แพ็คกิ้ง; เทปกาว, พลาสติกกันกระแทก, สายรัด",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                      Name: "PIECE",
                    },
                  ],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "360892ce-2fb4-ea11-a812-000d3a852c27",
              Name: "สินค้าเพื่อกิจกรรมทางการตลาดและงานแสดงสินค้า",
              Product: [
                {
                  id: "fd108aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "ชั้นวางเพื่อจัดแสดงสินค้า",
                  Product: [],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
      },
      {
        BussinessUnit: "PP",
        En: {
          Product: [
            {
              id: "8fcbb2aa-2fb4-ea11-a812-000d3a852c27",
              Name: "Paper for packaging",
              Product: [
                {
                  id: "ff108aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "BOX",
                  Product: [
                    {
                      id: "df4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Kraft Top Liner",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "e14d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Test Liner (Recycled)",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "e44d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Corrugating Medium",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "e64d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Coated Duplex Board",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "01118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Corrugated Sheet Board",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "6f8861f5-21e9-ea11-a817-000d3a85408a",
                      Name: "SHEET",
                    },
                  ],
                },
                {
                  id: "03118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Core and Cone",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "05118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Industrial Sack Kraft",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "07118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Sundry Bag Paper",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "09118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Gypsum Liner",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                  ],
                },
                {
                  id: "0b118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Converted Products",
                  Product: [
                    {
                      id: "e84d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Ream-Cut Paper",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "ea4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Small Width Slit Roll Paper",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                    {
                      id: "ec4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Multi-wall Sack",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "b5cc59fb-21e9-ea11-a817-000d3a85408a",
                          Name: "BAG",
                        },
                      ],
                    },
                    {
                      id: "ee4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "PE-Coated Paper",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "f04d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Kraft for Reinforcement and Protection",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "0d118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Inspirations from Paper",
                  Product: [
                    {
                      id: "f24d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Paper for Beautiful Prints",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "93a25807-22e9-ea11-a817-000d3a85408a",
                          Name: "SET",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
        Th: {
          Product: [
            {
              id: "8fcbb2aa-2fb4-ea11-a812-000d3a852c27",
              Name: "กระดาษบรรจุภัณฑ์",
              Product: [
                {
                  id: "ff108aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษทำกล่อง",
                  Product: [
                    {
                      id: "df4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษปะผิวชนิด Kraft Top",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "e14d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษปะผิวชนิด Testliner (Recycled)",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "e44d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษทำลอนลูกฟูก",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "e64d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษกล่องขาวเคลือบ",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "01118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "แผ่นกระดาษลูกฟูก",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "6f8861f5-21e9-ea11-a817-000d3a85408a",
                      Name: "SHEET",
                    },
                  ],
                },
                {
                  id: "03118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษสำหรับทำแกนและกรวย",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "05118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษสำหรับทำถุงอุตสาหกรรม",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "07118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษสำหรับทำถุงหรือซองเอกสาร",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "09118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษสำหรับผลิตแผ่นยิปซัม",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                  ],
                },
                {
                  id: "0b118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "สินค้าแปรรูป",
                  Product: [
                    {
                      id: "e84d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษตัดรีม",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "ea4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษม้วนกรอหน้าเล็ก",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                    {
                      id: "ec4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ถุงอุตสาหกรรมสำเร็จรูปหลายชั้น",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "b5cc59fb-21e9-ea11-a817-000d3a85408a",
                          Name: "BAG",
                        },
                      ],
                    },
                    {
                      id: "ee4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษเคลือบ",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "f04d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษคราฟท์เพื่องานเสริมแรง และปกป้อง",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "0d118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "แรงบันดาลใจจากกระดาษ",
                  Product: [
                    {
                      id: "f24d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษเพื่องานพิมพ์สวยงาม",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "93a25807-22e9-ea11-a817-000d3a85408a",
                          Name: "SET",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
      },
      {
        BussinessUnit: "FC",
        En: {
          Product: [
            {
              id: "11809fbc-2fb4-ea11-a812-000d3a852c27",
              Name: "Pulp and Paper",
              Product: [
                {
                  id: "15118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Pulp ",
                  Product: [
                    {
                      id: "064e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Bleached Pulp",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                    {
                      id: "084e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Unbleached Pulp",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                    {
                      id: "0a4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Dissolving Pulp",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                    {
                      id: "0c4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Semi-Chemical Pulp",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "17118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Printing and Writing Paper    ",
                  Product: [
                    {
                      id: "0e4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Uncoated Paper",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "104e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Coated Paper",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "124e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Environmental Friendly Paper",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "19118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Paper for copier",
                  Product: [
                    {
                      id: "144e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Idea",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "164e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Supreme",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "184e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Paper for copier (Rolls)",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "1b118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Machine Glaze Paper",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "1d118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Glassine Paper",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "b4957de7-2fb4-ea11-a812-000d3a852c27",
              Name: "Food Packaging and Related Products",
              Product: [
                {
                  id: "1f118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Fest Food Packaging ",
                  Product: [
                    {
                      id: "1a4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Fest Choice",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "1c4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Fest Bio",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "1e4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Fest Chill",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "21118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Others related Products",
                  Product: [
                    {
                      id: "204e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Paper Cone Cup",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "224e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Paper straw",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "244e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Plastic Lid",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "264e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Spoon",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "284e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Fork",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "ea51effd-2fb4-ea11-a812-000d3a852c27",
              Name: "Forestry and Related Products",
              Product: [
                {
                  id: "23118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Forestry Products",
                  Product: [
                    {
                      id: "2a4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Euca Siam",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "c1fe5c8f-22e9-ea11-a817-000d3a85408a",
                          Name: "TREE",
                        },
                      ],
                    },
                    {
                      id: "2c4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Biomass",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "64145a95-22e9-ea11-a817-000d3a85408a",
                          Name: "BDT",
                        },
                      ],
                    },
                    {
                      id: "2e4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Wood Pallet",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "304e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Wood Chip",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "64145a95-22e9-ea11-a817-000d3a85408a",
                          Name: "BDT",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "25118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Fertilizer and Agricultural Equipment",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "577d5fa7-22e9-ea11-a817-000d3a85408a",
                      Name: "RAI",
                    },
                  ],
                },
                {
                  id: "27118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Land Solution Service",
                  Product: [],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "0c64d64a-c0cc-ea11-a812-000d3a852c27",
              Name: "Cordyceps",
              Product: [
                {
                  id: "29118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Cordyceps",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                      Name: "BOX",
                    },
                  ],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
        Th: {
          Product: [
            {
              id: "11809fbc-2fb4-ea11-a812-000d3a852c27",
              Name: "กระดาษเยื่อและกระดาษ",
              Product: [
                {
                  id: "15118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "ผลิตภัณฑ์เยื่อ",
                  Product: [
                    {
                      id: "064e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "เยื่อฟอกขาว",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                    {
                      id: "084e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "เยื่อไม่ฟอกขาว",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                    {
                      id: "0a4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "เยื่อละลายได้",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                    {
                      id: "0c4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "เยื่อกึ่งเคมี",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "17118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษเพื่องานพิมพ์และเขียน     ",
                  Product: [
                    {
                      id: "0e4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษไม่เคลือบผิว",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "104e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษเคลือบผิว",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                    {
                      id: "124e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษที่เป็นมิตรต่อสิ่งแวดล้อม",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "19118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษถ่ายเอกสาร ",
                  Product: [
                    {
                      id: "144e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษถ่ายเอกสารไอเดีย",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "164e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษถ่ายเอกสารซุพรีม",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                          Name: "REAM",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "184e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระดาษถ่ายเอกสารแบบม้วน",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "1b118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษ Machine Glaze",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
                {
                  id: "1d118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "กระดาษรองหลังสติกเกอร์ ",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "TON",
                    },
                    {
                      id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                      Name: "ROLL",
                    },
                    {
                      id: "37bec2e8-21e9-ea11-a817-000d3a85408a",
                      Name: "REAM",
                    },
                  ],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "b4957de7-2fb4-ea11-a812-000d3a852c27",
              Name: "บรรจุภัณฑ์อาหารและสินค้าที่เกี่ยวข้อง",
              Product: [
                {
                  id: "1f118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "บรรจุภัณฑ์อาหารเฟสท์",
                  Product: [
                    {
                      id: "1a4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "เฟสท์ช้อยส์",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "1c4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "เฟสทืไบโอ",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "1e4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "เฟสท์ชิลล์",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "21118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "สินค้าที่เกี่ยวข้องอื่นๆ ",
                  Product: [
                    {
                      id: "204e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กรวยน้ำดื่ม",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "224e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "หลอดกระดาษ",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "244e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ฝาพลาสติก",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "264e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ช้อน",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                    {
                      id: "284e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ส้อม ",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                          Name: "BOX",
                        },
                        {
                          id: "f2ea6283-22e9-ea11-a817-000d3a85408a",
                          Name: "PACK",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "ea51effd-2fb4-ea11-a812-000d3a852c27",
              Name: "ธุรกิจไม้ครบวงจรและสินค้าที่เกี่ยวข้อง",
              Product: [
                {
                  id: "23118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "ธุรกิจไม้",
                  Product: [
                    {
                      id: "2a4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ยูคาสยาม",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "c1fe5c8f-22e9-ea11-a817-000d3a85408a",
                          Name: "TREE",
                        },
                      ],
                    },
                    {
                      id: "2c4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ชีวมวล",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "64145a95-22e9-ea11-a817-000d3a85408a",
                          Name: "BDT",
                        },
                      ],
                    },
                    {
                      id: "2e4e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระบะไม้",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "304e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ชิ้นไม้สับ",
                      Product: [],
                      minQty: null,
                      Unit: [
                        {
                          id: "406e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "TON",
                        },
                        {
                          id: "64145a95-22e9-ea11-a817-000d3a85408a",
                          Name: "BDT",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "25118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "ปุ๋ย และอุปกรณ์การเกษตร",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "577d5fa7-22e9-ea11-a817-000d3a85408a",
                      Name: "RAI",
                    },
                  ],
                },
                {
                  id: "27118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "บริการ Land Solution",
                  Product: [],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
            {
              id: "0c64d64a-c0cc-ea11-a812-000d3a852c27",
              Name: "ถั่งเช่า",
              Product: [
                {
                  id: "29118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "ถั่งเช่า",
                  Product: [],
                  minQty: null,
                  Unit: [
                    {
                      id: "6b2f6d77-22e9-ea11-a817-000d3a85408a",
                      Name: "BOX",
                    },
                  ],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
      },
      {
        BussinessUnit: "PPP",
        En: {
          Product: [
            {
              id: "5f2432c7-1de9-ea11-a817-000d3a85408a",
              Name: "Performance and Polymer Packaging",
              Product: [
                {
                  id: "0f118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Flexible Plastic Packaging",
                  Product: [
                    {
                      id: "f44d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Bag",
                      Product: [],
                      minQty: 50000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "b5cc59fb-21e9-ea11-a817-000d3a85408a",
                          Name: "BAG",
                        },
                      ],
                    },
                    {
                      id: "f64d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Roll",
                      Product: [],
                      minQty: 30,
                      Unit: [
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "11118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Rigid Plastic Packaging\nottle, Gallon, Bowl and Tube",
                  Product: [
                    {
                      id: "f84d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Bottle",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "fa4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Gallon",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "fc4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Bowl",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "fe4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Tube",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "13118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "Rigid Plastic Packaging: Oxygen High Barrier for Food",
                  Product: [
                    {
                      id: "004e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Tray",
                      Product: [],
                      minQty: 300000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "024e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Cup",
                      Product: [],
                      minQty: 300000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "044e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "Jar",
                      Product: [],
                      minQty: 60000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
        Th: {
          Product: [
            {
              id: "5f2432c7-1de9-ea11-a817-000d3a85408a",
              Name: "บรรจุภัณฑ์พอลิเมอร์",
              Product: [
                {
                  id: "0f118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "บรรจุภัณฑ์พลาสติกอ่อนตัว",
                  Product: [
                    {
                      id: "f44d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ถุง",
                      Product: [],
                      minQty: 50000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                        {
                          id: "b5cc59fb-21e9-ea11-a817-000d3a85408a",
                          Name: "BAG",
                        },
                      ],
                    },
                    {
                      id: "f64d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ม้วน",
                      Product: [],
                      minQty: 30,
                      Unit: [
                        {
                          id: "636e3be2-21e9-ea11-a817-000d3a85408a",
                          Name: "ROLL",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "11118aad-1fe9-ea11-a817-000d3a85432f",
                  Name: "บรรจุภัณฑ์พลาสติกคงรูป: ขวด, แกลลอน, กระปุก และ หลอด",
                  Product: [
                    {
                      id: "f84d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ขวด",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "fa4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "แกลลอน",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "fc4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "กระปุก",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "fe4d4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "หลอด",
                      Product: [],
                      minQty: 5000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
                {
                  id: "13118aad-1fe9-ea11-a817-000d3a85432f",
                  Name:
                    "บรรจุภัณฑ์พลาสติกคงรูป: ต้านทานการซึมผ่านของออกซิเจนสูงสำหรับอาหาร",
                  Product: [
                    {
                      id: "004e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ถาด",
                      Product: [],
                      minQty: 300000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "024e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ถ้วย",
                      Product: [],
                      minQty: 300000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                    {
                      id: "044e4d3a-21e9-ea11-a817-000d3a85432f",
                      Name: "ขวดปากกว้าง",
                      Product: [],
                      minQty: 60000,
                      Unit: [
                        {
                          id: "32d73340-5dd9-ea11-a813-000d3a8101d0",
                          Name: "PIECE",
                        },
                      ],
                    },
                  ],
                  minQty: null,
                  Unit: [],
                },
              ],
              minQty: null,
              Unit: null,
            },
          ],
        },
      },
    ],
    Country: [
      {
        Id: "e5a95765-4fb1-ea11-a812-000d3a852c27",
        Name: "Thailand",
        NameTH: "ไทย",
        CountryCode: "+66",
      },
      {
        Id: "16e4806b-4fb1-ea11-a812-000d3a852c27",
        Name: "Singapore",
        NameTH: "สิงคโปร์",
        CountryCode: "+65",
      },
      {
        Id: "1efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "United Arab Emirates",
        NameTH: "สหรัฐอาหรับเอมิเรตส์",
        CountryCode: "+971",
      },
      {
        Id: "20fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Afghanistan",
        NameTH: "อัฟกานิสถาน",
        CountryCode: "+93",
      },
      {
        Id: "22fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Albania",
        NameTH: "แอลเบเนีย",
        CountryCode: "+355",
      },
      {
        Id: "24fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Armenia",
        NameTH: "อาร์มีเนีย",
        CountryCode: "+374",
      },
      {
        Id: "26fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Angola",
        NameTH: "แองโกลา",
        CountryCode: "+244",
      },
      {
        Id: "28fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Argentina",
        NameTH: "อาร์เจนตินา",
        CountryCode: "+54",
      },
      {
        Id: "2afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Samoa, America",
        NameTH: "ซามัว",
        CountryCode: "+1-684",
      },
      {
        Id: "2cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Austria",
        NameTH: "ออสเตรีย",
        CountryCode: "+43",
      },
      {
        Id: "2efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Australia",
        NameTH: "ออสเตรเลีย",
        CountryCode: "+61",
      },
      {
        Id: "30fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Aruba",
        NameTH: "อาร์รูบาร์",
        CountryCode: "+297",
      },
      {
        Id: "32fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Azerbaijan",
        NameTH: "อาเซอร์ไบจาน",
        CountryCode: "+994",
      },
      {
        Id: "34fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Barbados",
        NameTH: "บาร์เบโดส",
        CountryCode: "+1-246",
      },
      {
        Id: "36fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bangladesh",
        NameTH: "บังกลาเทศ",
        CountryCode: "+880",
      },
      {
        Id: "38fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Belgium",
        NameTH: "เบลเยียม",
        CountryCode: "+32",
      },
      {
        Id: "3afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Burkina Faso",
        NameTH: "บูร์กินาฟาโซ",
        CountryCode: "+226",
      },
      {
        Id: "3cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bulgaria",
        NameTH: "บัลแกเรีย",
        CountryCode: "+359",
      },
      {
        Id: "3efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bahrain",
        NameTH: "บาห์เรน",
        CountryCode: "+973",
      },
      {
        Id: "40fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Burundi",
        NameTH: "บุรุนดี",
        CountryCode: "+257",
      },
      {
        Id: "42fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Benin",
        NameTH: "เบนิน",
        CountryCode: "+229",
      },
      {
        Id: "46fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bermuda",
        NameTH: "เบอร์มิวด้า",
        CountryCode: "+1-441",
      },
      {
        Id: "48fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Brunei Daruss.",
        NameTH: "บรูไน",
        CountryCode: "+673",
      },
      {
        Id: "4afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bolivia",
        NameTH: "โบลิเวีย",
        CountryCode: "+591",
      },
      {
        Id: "4cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Brazil",
        NameTH: "บราซิล",
        CountryCode: "+55",
      },
      {
        Id: "4efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bahamas",
        NameTH: "บาฮามาส",
        CountryCode: "+1-242",
      },
      {
        Id: "50fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bhutan",
        NameTH: "ภูฏาน",
        CountryCode: "+975",
      },
      {
        Id: "52fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bouvet Islands",
        NameTH: "หมู่เกาะบูเวต",
        CountryCode: "+47",
      },
      {
        Id: "54fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Botswana",
        NameTH: "บอตสวานา",
        CountryCode: "+267",
      },
      {
        Id: "56fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Belarus",
        NameTH: "เบลารุส",
        CountryCode: "+375",
      },
      {
        Id: "58fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Belize",
        NameTH: "เบลีซ",
        CountryCode: "+501",
      },
      {
        Id: "5afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Canada",
        NameTH: "แคนาดา",
        CountryCode: "+1",
      },
      {
        Id: "5cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Central African Republic",
        NameTH: "สาธารณรัฐแอฟริกากลาง",
        CountryCode: "+236",
      },
      {
        Id: "5efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Rep.of Congo",
        NameTH: "คองโก",
        CountryCode: "+242",
      },
      {
        Id: "60fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Switzerland",
        NameTH: "สวิตเซอร์แลนด์",
        CountryCode: "+41",
      },
      {
        Id: "62fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cote d'Ivoire",
        NameTH: "โกตดิวัวร์",
        CountryCode: "+225",
      },
      {
        Id: "64fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cook Islands",
        NameTH: "หมู่เกาะคุก",
        CountryCode: "+682",
      },
      {
        Id: "66fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Chile",
        NameTH: "ชิลี",
        CountryCode: "+56",
      },
      {
        Id: "68fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cameroon",
        NameTH: "แคเมอรูน",
        CountryCode: "+237",
      },
      {
        Id: "6afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "China",
        NameTH: "จีน",
        CountryCode: "+86",
      },
      {
        Id: "6cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Colombia",
        NameTH: "โคลอมเบีย",
        CountryCode: "+57",
      },
      {
        Id: "6efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Costa Rica",
        NameTH: "คอสตาริกา",
        CountryCode: "+506",
      },
      {
        Id: "70fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cuba",
        NameTH: "คิวบา",
        CountryCode: "+53",
      },
      {
        Id: "72fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cape Verde",
        NameTH: "เคปเวิร์ด",
        CountryCode: "+238",
      },
      {
        Id: "74fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cyprus",
        NameTH: "ไซปรัส",
        CountryCode: "+357",
      },
      {
        Id: "76fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Czech Republic",
        NameTH: "สาธารณรัฐเช็ก",
        CountryCode: "+420",
      },
      {
        Id: "78fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Germany",
        NameTH: "เยอรมนี",
        CountryCode: "+49",
      },
      {
        Id: "7afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Djibouti",
        NameTH: "จิบูตี",
        CountryCode: "+253",
      },
      {
        Id: "7cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Denmark",
        NameTH: "เดนมาร์ก",
        CountryCode: "+45",
      },
      {
        Id: "7efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Dominican Rep.",
        NameTH: "สาธารณรัฐโดมินิกัน",
        CountryCode: "+1-809",
      },
      {
        Id: "80fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Algeria",
        NameTH: "แอลจีเรีย",
        CountryCode: "+213",
      },
      {
        Id: "82fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ecuador",
        NameTH: "เอกวาดอร์",
        CountryCode: "+593",
      },
      {
        Id: "84fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Estonia",
        NameTH: "เอสโตเนีย",
        CountryCode: "+372",
      },
      {
        Id: "86fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Egypt",
        NameTH: "อียิปต์",
        CountryCode: "+20",
      },
      {
        Id: "88fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Eritrea",
        NameTH: "เอริเทรีย",
        CountryCode: "+291",
      },
      {
        Id: "8afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Spain",
        NameTH: "สเปน",
        CountryCode: "+34",
      },
      {
        Id: "8cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ethiopia",
        NameTH: "เอธิโอเปีย",
        CountryCode: "+251",
      },
      {
        Id: "90fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Finland",
        NameTH: "ฟินแลนด์",
        CountryCode: "+358",
      },
      {
        Id: "92fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Fiji",
        NameTH: "ฟิจิ",
        CountryCode: "+679",
      },
      {
        Id: "94fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Micronesia",
        NameTH: "ไมโครนีเซีย",
        CountryCode: "+691",
      },
      {
        Id: "96fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "France",
        NameTH: "ฝรั่งเศส",
        CountryCode: "+33",
      },
      {
        Id: "98fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Gabon",
        NameTH: "กาบอง",
        CountryCode: "+241",
      },
      {
        Id: "9afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "United Kingdom",
        NameTH: "สหราชอาณาจักร",
        CountryCode: "+44",
      },
      {
        Id: "9cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Georgia",
        NameTH: "จอร์เจีย",
        CountryCode: "+995",
      },
      {
        Id: "9efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ghana",
        NameTH: "กานา",
        CountryCode: "+233",
      },
      {
        Id: "a0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Gibraltar",
        NameTH: "ยิบรอลตาร์",
        CountryCode: "+350",
      },
      {
        Id: "a2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Gambia",
        NameTH: "แกมเบีย",
        CountryCode: "+220",
      },
      {
        Id: "a4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guinea",
        NameTH: "กินี",
        CountryCode: "+224",
      },
      {
        Id: "a6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guadeloupe",
        NameTH: "กวาเดอลูป",
        CountryCode: "+590",
      },
      {
        Id: "a8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Greece",
        NameTH: "กรีซ",
        CountryCode: "+30",
      },
      {
        Id: "aafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guatemala",
        NameTH: "กัวเตมาลา",
        CountryCode: "+502",
      },
      {
        Id: "acfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guam",
        NameTH: "กวม",
        CountryCode: "+1-671",
      },
      {
        Id: "aefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guinea-Bissau",
        NameTH: "กินี-บิสเซา",
        CountryCode: "+245",
      },
      {
        Id: "b0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guyana",
        NameTH: "กายอานา",
        CountryCode: "+592",
      },
      {
        Id: "b2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Hong Kong",
        NameTH: "ฮ่องกง",
        CountryCode: "+852",
      },
      {
        Id: "b4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Honduras",
        NameTH: "ฮอนดูรัส",
        CountryCode: "+504",
      },
      {
        Id: "b6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Croatia",
        NameTH: "โครเอเชีย",
        CountryCode: "+385",
      },
      {
        Id: "b8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Haiti",
        NameTH: "เฮติ",
        CountryCode: "+509",
      },
      {
        Id: "bafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Hungary",
        NameTH: "ฮังการี",
        CountryCode: "+36",
      },
      {
        Id: "bcfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Indonesia",
        NameTH: "อินโดนีเซีย",
        CountryCode: "+62",
      },
      {
        Id: "befc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ireland",
        NameTH: "ไอร์แลนด์",
        CountryCode: "+353",
      },
      {
        Id: "c0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Israel",
        NameTH: "อิสราเอล",
        CountryCode: "+972",
      },
      {
        Id: "c2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "India",
        NameTH: "อินเดีย",
        CountryCode: "+91",
      },
      {
        Id: "c4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Iraq",
        NameTH: "อิรัก",
        CountryCode: "+964",
      },
      {
        Id: "c6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Iran",
        NameTH: "อิหร่าน",
        CountryCode: "+98",
      },
      {
        Id: "c8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Iceland",
        NameTH: "ไอซ์แลนด์",
        CountryCode: "+354",
      },
      {
        Id: "cafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Italy",
        NameTH: "อิตาลี",
        CountryCode: "+39",
      },
      {
        Id: "ccfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Jamaica",
        NameTH: "จาเมกา",
        CountryCode: "+1-876",
      },
      {
        Id: "cefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Jordan",
        NameTH: "จอร์แดน",
        CountryCode: "+962",
      },
      {
        Id: "d0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Japan",
        NameTH: "ญี่ปุ่น",
        CountryCode: "+81",
      },
      {
        Id: "d2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Kenya",
        NameTH: "เคนยา",
        CountryCode: "+254",
      },
      {
        Id: "d4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cambodia",
        NameTH: "กัมพูชา",
        CountryCode: "+855",
      },
      {
        Id: "d6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Comoros",
        NameTH: "คอโมโรส",
        CountryCode: "+269",
      },
      {
        Id: "d8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "North Korea",
        NameTH: "เกาหลีเหนือ",
        CountryCode: "+850",
      },
      {
        Id: "dafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "South Korea",
        NameTH: "เกาหลีใต้",
        CountryCode: "+82",
      },
      {
        Id: "dcfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Kuwait",
        NameTH: "คูเวต",
        CountryCode: "+965",
      },
      {
        Id: "defc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cayman Islands",
        NameTH: "หมู่เกาะเคย์แมน",
        CountryCode: "+1-345",
      },
      {
        Id: "e0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Kazakhstan",
        NameTH: "คาซัคสถาน",
        CountryCode: "+7",
      },
      {
        Id: "e2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Laos",
        NameTH: "ลาว",
        CountryCode: "+856",
      },
      {
        Id: "e4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Lebanon",
        NameTH: "เลบานอน",
        CountryCode: "+961",
      },
      {
        Id: "e6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "St. Lucia",
        NameTH: "เซนต์ลูเซีย",
        CountryCode: "+1-758",
      },
      {
        Id: "e8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sri Lanka",
        NameTH: "ศรีลังกา",
        CountryCode: "+94",
      },
      {
        Id: "eafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Liberia",
        NameTH: "ไลบีเรีย",
        CountryCode: "+231",
      },
      {
        Id: "ecfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Lithuania",
        NameTH: "ลิทัวเนีย",
        CountryCode: "+370",
      },
      {
        Id: "eefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Luxembourg",
        NameTH: "ลักเซมเบิร์ก",
        CountryCode: "+352",
      },
      {
        Id: "f0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Latvia",
        NameTH: "ลัตเวีย",
        CountryCode: "+371",
      },
      {
        Id: "f2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Libya",
        NameTH: "ลิเบีย",
        CountryCode: "+218",
      },
      {
        Id: "f4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Morocco",
        NameTH: "โมร็อกโก",
        CountryCode: "+212",
      },
      {
        Id: "f6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Monaco",
        NameTH: "โมนาโก",
        CountryCode: "+377",
      },
      {
        Id: "f8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Moldova",
        NameTH: "มอลโดวา",
        CountryCode: "+373",
      },
      {
        Id: "fafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Montenegro",
        NameTH: "มอนเตเนโกร",
        CountryCode: "+382",
      },
      {
        Id: "fcfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Madagascar",
        NameTH: "มาดากัสการ์",
        CountryCode: "+261",
      },
      {
        Id: "fefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Marshall Islnds",
        NameTH: "มาร์แชลล์อิสลันด์",
        CountryCode: "+692",
      },
      {
        Id: "00fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Macedonia",
        NameTH: "มาซิโดเนีย",
        CountryCode: "+389",
      },
      {
        Id: "02fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mali",
        NameTH: "มาลี",
        CountryCode: "+223",
      },
      {
        Id: "04fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Myanmar",
        NameTH: "พม่า",
        CountryCode: "+95",
      },
      {
        Id: "06fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mongolia",
        NameTH: "มองโกเลีย",
        CountryCode: "+976",
      },
      {
        Id: "08fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Macau",
        NameTH: "มาเก๊า",
        CountryCode: "+853",
      },
      {
        Id: "0afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Northern Mariana Islands",
        NameTH: "หมู่เกาะนอร์เทิร์นมาเรียนา",
        CountryCode: "+1-670",
      },
      {
        Id: "0cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Martinique",
        NameTH: "มาร์ตินีก",
        CountryCode: "+596",
      },
      {
        Id: "0efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mauretania",
        NameTH: "มอเรทาเนีย",
        CountryCode: "+222",
      },
      {
        Id: "10fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Malta",
        NameTH: "มอลตา",
        CountryCode: "+356",
      },
      {
        Id: "12fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mauritius",
        NameTH: "มอริเชียส",
        CountryCode: "+230",
      },
      {
        Id: "14fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Maldives",
        NameTH: "มัลดีฟส์",
        CountryCode: "+960",
      },
      {
        Id: "16fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Malawi",
        NameTH: "มาลาวี",
        CountryCode: "+265",
      },
      {
        Id: "18fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mexico",
        NameTH: "เม็กซิโก",
        CountryCode: "+52",
      },
      {
        Id: "1afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Malaysia",
        NameTH: "มาเลเซีย",
        CountryCode: "+60",
      },
      {
        Id: "1cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mozambique",
        NameTH: "โมซัมบิก",
        CountryCode: "+258",
      },
      {
        Id: "1efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Namibia",
        NameTH: "นามิเบีย",
        CountryCode: "+264",
      },
      {
        Id: "20fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "New Caledonia",
        NameTH: "นิวแคลิโดเนีย",
        CountryCode: "+687",
      },
      {
        Id: "22fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Nigeria",
        NameTH: "ไนจีเรีย",
        CountryCode: "+234",
      },
      {
        Id: "24fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Nicaragua",
        NameTH: "นิการากัว",
        CountryCode: "+505",
      },
      {
        Id: "26fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Netherlands",
        NameTH: "เนเธอร์แลนด์",
        CountryCode: "+31",
      },
      {
        Id: "28fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Norway",
        NameTH: "นอร์เวย์",
        CountryCode: "+47",
      },
      {
        Id: "2afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Nepal",
        NameTH: "เนปาล",
        CountryCode: "+977",
      },
      {
        Id: "2cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "New Zealand",
        NameTH: "นิวซีแลนด์",
        CountryCode: "+64",
      },
      {
        Id: "2efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Oman",
        NameTH: "โอมาน",
        CountryCode: "+968",
      },
      {
        Id: "32fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Panama",
        NameTH: "ปานามา",
        CountryCode: "+507",
      },
      {
        Id: "34fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Peru",
        NameTH: "เปรู",
        CountryCode: "+51",
      },
      {
        Id: "36fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Frenc.Polynesia",
        NameTH: "เฟรนช์โปลินีเซีย",
        CountryCode: "+689",
      },
      {
        Id: "38fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Pap. New Guinea",
        NameTH: "ปาปัวร์นิวกินี",
        CountryCode: "+675",
      },
      {
        Id: "3afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Philippines",
        NameTH: "ฟิลิปปินส์",
        CountryCode: "+63",
      },
      {
        Id: "3cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Pakistan",
        NameTH: "ปากีสถาน",
        CountryCode: "+92",
      },
      {
        Id: "3efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Poland",
        NameTH: "โปแลนด์",
        CountryCode: "+48",
      },
      {
        Id: "40fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Puerto Rico",
        NameTH: "เปอร์โตริโก้",
        CountryCode: "+1",
      },
      {
        Id: "42fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Palestine",
        NameTH: "ปาเลสไตน์",
        CountryCode: "+970",
      },
      {
        Id: "44fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Portugal",
        NameTH: "โปรตุเกส",
        CountryCode: "+351",
      },
      {
        Id: "46fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Palau",
        NameTH: "ปาเลา",
        CountryCode: "+680",
      },
      {
        Id: "48fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Paraguay",
        NameTH: "ปารากวัย",
        CountryCode: "+595",
      },
      {
        Id: "4afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Qatar",
        NameTH: "กาตาร์",
        CountryCode: "+974",
      },
      {
        Id: "4cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Reunion",
        NameTH: "เรอูนียง",
        CountryCode: "+262",
      },
      {
        Id: "4efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Romania",
        NameTH: "โรมาเนีย",
        CountryCode: "+40",
      },
      {
        Id: "50fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Russian Fed.",
        NameTH: "เฟดรัสเซีย",
        CountryCode: "+7",
      },
      {
        Id: "52fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Rwanda",
        NameTH: "รวันดา",
        CountryCode: "+250",
      },
      {
        Id: "54fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Saudi Arabia",
        NameTH: "ซาอุดีอาระเบีย",
        CountryCode: "+966",
      },
      {
        Id: "56fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Solomon Islands",
        NameTH: "หมู่เกาะโซโลมอน",
        CountryCode: "+677",
      },
      {
        Id: "58fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Seychelles",
        NameTH: "เซเชลส์",
        CountryCode: "+248",
      },
      {
        Id: "5afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sudan",
        NameTH: "ซูดาน",
        CountryCode: "+249",
      },
      {
        Id: "5cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sweden",
        NameTH: "สวีเดน",
        CountryCode: "+46",
      },
      {
        Id: "60fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Slovenia",
        NameTH: "สโลวีเนีย",
        CountryCode: "+386",
      },
      {
        Id: "62fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sierra Leone",
        NameTH: "เซียร์ราลีโอน",
        CountryCode: "+232",
      },
      {
        Id: "64fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Senegal",
        NameTH: "เซเนกัล",
        CountryCode: "+221",
      },
      {
        Id: "66fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Somalia",
        NameTH: "โซมาเลีย",
        CountryCode: "+252",
      },
      {
        Id: "68fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Suriname",
        NameTH: "ซูรินาม",
        CountryCode: "+597",
      },
      {
        Id: "6afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "El Salvador",
        NameTH: "เอลซัลวาดอร์",
        CountryCode: "+503",
      },
      {
        Id: "6efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Syria",
        NameTH: "ซีเรีย",
        CountryCode: "+963",
      },
      {
        Id: "70fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Togo",
        NameTH: "โตโก",
        CountryCode: "+228",
      },
      {
        Id: "74fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Turkmenistan",
        NameTH: "เติร์กเมนิสถาน",
        CountryCode: "+993",
      },
      {
        Id: "76fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tunisia",
        NameTH: "ตูนิเซีย",
        CountryCode: "+216",
      },
      {
        Id: "78fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tonga",
        NameTH: "ตองกา",
        CountryCode: "+676",
      },
      {
        Id: "7cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Turkey",
        NameTH: "ตุรกี",
        CountryCode: "+90",
      },
      {
        Id: "7efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Trinidad,Tobago",
        NameTH: "ตรินิแดดโตเบโก",
        CountryCode: "+1-868",
      },
      {
        Id: "80fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tuvalu",
        NameTH: "ตูวาลู",
        CountryCode: "+688",
      },
      {
        Id: "82fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Taiwan",
        NameTH: "ไต้หวัน",
        CountryCode: "+886",
      },
      {
        Id: "84fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tanzania",
        NameTH: "แทนซาเนีย",
        CountryCode: "+255",
      },
      {
        Id: "86fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ukraine",
        NameTH: "ยูเครน",
        CountryCode: "+380",
      },
      {
        Id: "88fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Uganda",
        NameTH: "ยูกันดา",
        CountryCode: "+256",
      },
      {
        Id: "8afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "United States of America",
        NameTH: "สหรัฐอเมริกา",
        CountryCode: "+1",
      },
      {
        Id: "8cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Uruguay",
        NameTH: "อุรุกวัย",
        CountryCode: "+598",
      },
      {
        Id: "8efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Uzbekistan",
        NameTH: "อุซเบกิสถาน",
        CountryCode: "+998",
      },
      {
        Id: "90fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Venezuela",
        NameTH: "เวเนซุเอลา",
        CountryCode: "+58",
      },
      {
        Id: "92fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Brit.Virgin Is.",
        NameTH: "หมู่เกาะบริตริสเวอร์จิน",
        CountryCode: "+1-284",
      },
      {
        Id: "94fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Vietnam",
        NameTH: "เวียดนาม",
        CountryCode: "+84",
      },
      {
        Id: "96fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Samoa",
        NameTH: "ซามัว",
        CountryCode: "+685",
      },
      {
        Id: "98fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Yemen",
        NameTH: "เยเมน",
        CountryCode: "+967",
      },
      {
        Id: "9afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mayotte",
        NameTH: "มายอต",
        CountryCode: "+262",
      },
      {
        Id: "9cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "South Africa",
        NameTH: "แอฟริกาใต้",
        CountryCode: "+27",
      },
      {
        Id: "9efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Zambia",
        NameTH: "แซมเบีย",
        CountryCode: "+260",
      },
      {
        Id: "a0fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Zimbabwe",
        NameTH: "ซิมบับเว",
        CountryCode: "+263",
      },
    ],
    CustomerCountry: [
      {
        Id: "e5a95765-4fb1-ea11-a812-000d3a852c27",
        Name: "Thailand",
        NameTH: "ไทย",
        CountryCode: "+66",
      },
      {
        Id: "16e4806b-4fb1-ea11-a812-000d3a852c27",
        Name: "Singapore",
        NameTH: "สิงคโปร์",
        CountryCode: "+65",
      },
      {
        Id: "1efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "United Arab Emirates",
        NameTH: "สหรัฐอาหรับเอมิเรตส์",
        CountryCode: "+971",
      },
      {
        Id: "20fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Afghanistan",
        NameTH: "อัฟกานิสถาน",
        CountryCode: "+93",
      },
      {
        Id: "22fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Albania",
        NameTH: "แอลเบเนีย",
        CountryCode: "+355",
      },
      {
        Id: "24fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Armenia",
        NameTH: "อาร์มีเนีย",
        CountryCode: "+374",
      },
      {
        Id: "26fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Angola",
        NameTH: "แองโกลา",
        CountryCode: "+244",
      },
      {
        Id: "28fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Argentina",
        NameTH: "อาร์เจนตินา",
        CountryCode: "+54",
      },
      {
        Id: "2afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Samoa, America",
        NameTH: "ซามัว",
        CountryCode: "+1-684",
      },
      {
        Id: "2cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Austria",
        NameTH: "ออสเตรีย",
        CountryCode: "+43",
      },
      {
        Id: "2efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Australia",
        NameTH: "ออสเตรเลีย",
        CountryCode: "+61",
      },
      {
        Id: "30fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Aruba",
        NameTH: "อาร์รูบาร์",
        CountryCode: "+297",
      },
      {
        Id: "32fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Azerbaijan",
        NameTH: "อาเซอร์ไบจาน",
        CountryCode: "+994",
      },
      {
        Id: "34fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Barbados",
        NameTH: "บาร์เบโดส",
        CountryCode: "+1-246",
      },
      {
        Id: "36fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bangladesh",
        NameTH: "บังกลาเทศ",
        CountryCode: "+880",
      },
      {
        Id: "38fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Belgium",
        NameTH: "เบลเยียม",
        CountryCode: "+32",
      },
      {
        Id: "3afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Burkina Faso",
        NameTH: "บูร์กินาฟาโซ",
        CountryCode: "+226",
      },
      {
        Id: "3cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bulgaria",
        NameTH: "บัลแกเรีย",
        CountryCode: "+359",
      },
      {
        Id: "3efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bahrain",
        NameTH: "บาห์เรน",
        CountryCode: "+973",
      },
      {
        Id: "40fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Burundi",
        NameTH: "บุรุนดี",
        CountryCode: "+257",
      },
      {
        Id: "42fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Benin",
        NameTH: "เบนิน",
        CountryCode: "+229",
      },
      {
        Id: "46fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bermuda",
        NameTH: "เบอร์มิวด้า",
        CountryCode: "+1-441",
      },
      {
        Id: "48fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Brunei Daruss.",
        NameTH: "บรูไน",
        CountryCode: "+673",
      },
      {
        Id: "4afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bolivia",
        NameTH: "โบลิเวีย",
        CountryCode: "+591",
      },
      {
        Id: "4cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Brazil",
        NameTH: "บราซิล",
        CountryCode: "+55",
      },
      {
        Id: "4efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bahamas",
        NameTH: "บาฮามาส",
        CountryCode: "+1-242",
      },
      {
        Id: "50fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bhutan",
        NameTH: "ภูฏาน",
        CountryCode: "+975",
      },
      {
        Id: "52fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Bouvet Islands",
        NameTH: "หมู่เกาะบูเวต",
        CountryCode: "+47",
      },
      {
        Id: "54fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Botswana",
        NameTH: "บอตสวานา",
        CountryCode: "+267",
      },
      {
        Id: "56fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Belarus",
        NameTH: "เบลารุส",
        CountryCode: "+375",
      },
      {
        Id: "58fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Belize",
        NameTH: "เบลีซ",
        CountryCode: "+501",
      },
      {
        Id: "5afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Canada",
        NameTH: "แคนาดา",
        CountryCode: "+1",
      },
      {
        Id: "5cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Central African Republic",
        NameTH: "สาธารณรัฐแอฟริกากลาง",
        CountryCode: "+236",
      },
      {
        Id: "5efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Rep.of Congo",
        NameTH: "คองโก",
        CountryCode: "+242",
      },
      {
        Id: "60fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Switzerland",
        NameTH: "สวิตเซอร์แลนด์",
        CountryCode: "+41",
      },
      {
        Id: "62fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cote d'Ivoire",
        NameTH: "โกตดิวัวร์",
        CountryCode: "+225",
      },
      {
        Id: "64fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cook Islands",
        NameTH: "หมู่เกาะคุก",
        CountryCode: "+682",
      },
      {
        Id: "66fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Chile",
        NameTH: "ชิลี",
        CountryCode: "+56",
      },
      {
        Id: "68fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cameroon",
        NameTH: "แคเมอรูน",
        CountryCode: "+237",
      },
      {
        Id: "6afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "China",
        NameTH: "จีน",
        CountryCode: "+86",
      },
      {
        Id: "6cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Colombia",
        NameTH: "โคลอมเบีย",
        CountryCode: "+57",
      },
      {
        Id: "6efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Costa Rica",
        NameTH: "คอสตาริกา",
        CountryCode: "+506",
      },
      {
        Id: "70fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cuba",
        NameTH: "คิวบา",
        CountryCode: "+53",
      },
      {
        Id: "72fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cape Verde",
        NameTH: "เคปเวิร์ด",
        CountryCode: "+238",
      },
      {
        Id: "74fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cyprus",
        NameTH: "ไซปรัส",
        CountryCode: "+357",
      },
      {
        Id: "76fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Czech Republic",
        NameTH: "สาธารณรัฐเช็ก",
        CountryCode: "+420",
      },
      {
        Id: "78fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Germany",
        NameTH: "เยอรมนี",
        CountryCode: "+49",
      },
      {
        Id: "7afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Djibouti",
        NameTH: "จิบูตี",
        CountryCode: "+253",
      },
      {
        Id: "7cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Denmark",
        NameTH: "เดนมาร์ก",
        CountryCode: "+45",
      },
      {
        Id: "7efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Dominican Rep.",
        NameTH: "สาธารณรัฐโดมินิกัน",
        CountryCode: "+1-809",
      },
      {
        Id: "80fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Algeria",
        NameTH: "แอลจีเรีย",
        CountryCode: "+213",
      },
      {
        Id: "82fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ecuador",
        NameTH: "เอกวาดอร์",
        CountryCode: "+593",
      },
      {
        Id: "84fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Estonia",
        NameTH: "เอสโตเนีย",
        CountryCode: "+372",
      },
      {
        Id: "86fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Egypt",
        NameTH: "อียิปต์",
        CountryCode: "+20",
      },
      {
        Id: "88fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Eritrea",
        NameTH: "เอริเทรีย",
        CountryCode: "+291",
      },
      {
        Id: "8afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Spain",
        NameTH: "สเปน",
        CountryCode: "+34",
      },
      {
        Id: "8cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ethiopia",
        NameTH: "เอธิโอเปีย",
        CountryCode: "+251",
      },
      {
        Id: "90fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Finland",
        NameTH: "ฟินแลนด์",
        CountryCode: "+358",
      },
      {
        Id: "92fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Fiji",
        NameTH: "ฟิจิ",
        CountryCode: "+679",
      },
      {
        Id: "94fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Micronesia",
        NameTH: "ไมโครนีเซีย",
        CountryCode: "+691",
      },
      {
        Id: "96fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "France",
        NameTH: "ฝรั่งเศส",
        CountryCode: "+33",
      },
      {
        Id: "98fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Gabon",
        NameTH: "กาบอง",
        CountryCode: "+241",
      },
      {
        Id: "9afc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "United Kingdom",
        NameTH: "สหราชอาณาจักร",
        CountryCode: "+44",
      },
      {
        Id: "9cfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Georgia",
        NameTH: "จอร์เจีย",
        CountryCode: "+995",
      },
      {
        Id: "9efc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ghana",
        NameTH: "กานา",
        CountryCode: "+233",
      },
      {
        Id: "a0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Gibraltar",
        NameTH: "ยิบรอลตาร์",
        CountryCode: "+350",
      },
      {
        Id: "a2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Gambia",
        NameTH: "แกมเบีย",
        CountryCode: "+220",
      },
      {
        Id: "a4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guinea",
        NameTH: "กินี",
        CountryCode: "+224",
      },
      {
        Id: "a6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guadeloupe",
        NameTH: "กวาเดอลูป",
        CountryCode: "+590",
      },
      {
        Id: "a8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Greece",
        NameTH: "กรีซ",
        CountryCode: "+30",
      },
      {
        Id: "aafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guatemala",
        NameTH: "กัวเตมาลา",
        CountryCode: "+502",
      },
      {
        Id: "acfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guam",
        NameTH: "กวม",
        CountryCode: "+1-671",
      },
      {
        Id: "aefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guinea-Bissau",
        NameTH: "กินี-บิสเซา",
        CountryCode: "+245",
      },
      {
        Id: "b0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Guyana",
        NameTH: "กายอานา",
        CountryCode: "+592",
      },
      {
        Id: "b2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Hong Kong",
        NameTH: "ฮ่องกง",
        CountryCode: "+852",
      },
      {
        Id: "b4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Honduras",
        NameTH: "ฮอนดูรัส",
        CountryCode: "+504",
      },
      {
        Id: "b6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Croatia",
        NameTH: "โครเอเชีย",
        CountryCode: "+385",
      },
      {
        Id: "b8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Haiti",
        NameTH: "เฮติ",
        CountryCode: "+509",
      },
      {
        Id: "bafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Hungary",
        NameTH: "ฮังการี",
        CountryCode: "+36",
      },
      {
        Id: "bcfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Indonesia",
        NameTH: "อินโดนีเซีย",
        CountryCode: "+62",
      },
      {
        Id: "befc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ireland",
        NameTH: "ไอร์แลนด์",
        CountryCode: "+353",
      },
      {
        Id: "c0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Israel",
        NameTH: "อิสราเอล",
        CountryCode: "+972",
      },
      {
        Id: "c2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "India",
        NameTH: "อินเดีย",
        CountryCode: "+91",
      },
      {
        Id: "c4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Iraq",
        NameTH: "อิรัก",
        CountryCode: "+964",
      },
      {
        Id: "c6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Iran",
        NameTH: "อิหร่าน",
        CountryCode: "+98",
      },
      {
        Id: "c8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Iceland",
        NameTH: "ไอซ์แลนด์",
        CountryCode: "+354",
      },
      {
        Id: "cafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Italy",
        NameTH: "อิตาลี",
        CountryCode: "+39",
      },
      {
        Id: "ccfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Jamaica",
        NameTH: "จาเมกา",
        CountryCode: "+1-876",
      },
      {
        Id: "cefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Jordan",
        NameTH: "จอร์แดน",
        CountryCode: "+962",
      },
      {
        Id: "d0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Japan",
        NameTH: "ญี่ปุ่น",
        CountryCode: "+81",
      },
      {
        Id: "d2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Kenya",
        NameTH: "เคนยา",
        CountryCode: "+254",
      },
      {
        Id: "d4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cambodia",
        NameTH: "กัมพูชา",
        CountryCode: "+855",
      },
      {
        Id: "d6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Comoros",
        NameTH: "คอโมโรส",
        CountryCode: "+269",
      },
      {
        Id: "d8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "North Korea",
        NameTH: "เกาหลีเหนือ",
        CountryCode: "+850",
      },
      {
        Id: "dafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "South Korea",
        NameTH: "เกาหลีใต้",
        CountryCode: "+82",
      },
      {
        Id: "dcfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Kuwait",
        NameTH: "คูเวต",
        CountryCode: "+965",
      },
      {
        Id: "defc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Cayman Islands",
        NameTH: "หมู่เกาะเคย์แมน",
        CountryCode: "+1-345",
      },
      {
        Id: "e0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Kazakhstan",
        NameTH: "คาซัคสถาน",
        CountryCode: "+7",
      },
      {
        Id: "e2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Laos",
        NameTH: "ลาว",
        CountryCode: "+856",
      },
      {
        Id: "e4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Lebanon",
        NameTH: "เลบานอน",
        CountryCode: "+961",
      },
      {
        Id: "e6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "St. Lucia",
        NameTH: "เซนต์ลูเซีย",
        CountryCode: "+1-758",
      },
      {
        Id: "e8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sri Lanka",
        NameTH: "ศรีลังกา",
        CountryCode: "+94",
      },
      {
        Id: "eafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Liberia",
        NameTH: "ไลบีเรีย",
        CountryCode: "+231",
      },
      {
        Id: "ecfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Lithuania",
        NameTH: "ลิทัวเนีย",
        CountryCode: "+370",
      },
      {
        Id: "eefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Luxembourg",
        NameTH: "ลักเซมเบิร์ก",
        CountryCode: "+352",
      },
      {
        Id: "f0fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Latvia",
        NameTH: "ลัตเวีย",
        CountryCode: "+371",
      },
      {
        Id: "f2fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Libya",
        NameTH: "ลิเบีย",
        CountryCode: "+218",
      },
      {
        Id: "f4fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Morocco",
        NameTH: "โมร็อกโก",
        CountryCode: "+212",
      },
      {
        Id: "f6fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Monaco",
        NameTH: "โมนาโก",
        CountryCode: "+377",
      },
      {
        Id: "f8fc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Moldova",
        NameTH: "มอลโดวา",
        CountryCode: "+373",
      },
      {
        Id: "fafc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Montenegro",
        NameTH: "มอนเตเนโกร",
        CountryCode: "+382",
      },
      {
        Id: "fcfc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Madagascar",
        NameTH: "มาดากัสการ์",
        CountryCode: "+261",
      },
      {
        Id: "fefc0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Marshall Islnds",
        NameTH: "มาร์แชลล์อิสลันด์",
        CountryCode: "+692",
      },
      {
        Id: "00fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Macedonia",
        NameTH: "มาซิโดเนีย",
        CountryCode: "+389",
      },
      {
        Id: "02fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mali",
        NameTH: "มาลี",
        CountryCode: "+223",
      },
      {
        Id: "04fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Myanmar",
        NameTH: "พม่า",
        CountryCode: "+95",
      },
      {
        Id: "06fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mongolia",
        NameTH: "มองโกเลีย",
        CountryCode: "+976",
      },
      {
        Id: "08fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Macau",
        NameTH: "มาเก๊า",
        CountryCode: "+853",
      },
      {
        Id: "0afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Northern Mariana Islands",
        NameTH: "หมู่เกาะนอร์เทิร์นมาเรียนา",
        CountryCode: "+1-670",
      },
      {
        Id: "0cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Martinique",
        NameTH: "มาร์ตินีก",
        CountryCode: "+596",
      },
      {
        Id: "0efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mauretania",
        NameTH: "มอเรทาเนีย",
        CountryCode: "+222",
      },
      {
        Id: "10fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Malta",
        NameTH: "มอลตา",
        CountryCode: "+356",
      },
      {
        Id: "12fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mauritius",
        NameTH: "มอริเชียส",
        CountryCode: "+230",
      },
      {
        Id: "14fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Maldives",
        NameTH: "มัลดีฟส์",
        CountryCode: "+960",
      },
      {
        Id: "16fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Malawi",
        NameTH: "มาลาวี",
        CountryCode: "+265",
      },
      {
        Id: "18fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mexico",
        NameTH: "เม็กซิโก",
        CountryCode: "+52",
      },
      {
        Id: "1afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Malaysia",
        NameTH: "มาเลเซีย",
        CountryCode: "+60",
      },
      {
        Id: "1cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mozambique",
        NameTH: "โมซัมบิก",
        CountryCode: "+258",
      },
      {
        Id: "1efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Namibia",
        NameTH: "นามิเบีย",
        CountryCode: "+264",
      },
      {
        Id: "20fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "New Caledonia",
        NameTH: "นิวแคลิโดเนีย",
        CountryCode: "+687",
      },
      {
        Id: "22fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Nigeria",
        NameTH: "ไนจีเรีย",
        CountryCode: "+234",
      },
      {
        Id: "24fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Nicaragua",
        NameTH: "นิการากัว",
        CountryCode: "+505",
      },
      {
        Id: "26fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Netherlands",
        NameTH: "เนเธอร์แลนด์",
        CountryCode: "+31",
      },
      {
        Id: "28fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Norway",
        NameTH: "นอร์เวย์",
        CountryCode: "+47",
      },
      {
        Id: "2afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Nepal",
        NameTH: "เนปาล",
        CountryCode: "+977",
      },
      {
        Id: "2cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "New Zealand",
        NameTH: "นิวซีแลนด์",
        CountryCode: "+64",
      },
      {
        Id: "2efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Oman",
        NameTH: "โอมาน",
        CountryCode: "+968",
      },
      {
        Id: "32fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Panama",
        NameTH: "ปานามา",
        CountryCode: "+507",
      },
      {
        Id: "34fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Peru",
        NameTH: "เปรู",
        CountryCode: "+51",
      },
      {
        Id: "36fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Frenc.Polynesia",
        NameTH: "เฟรนช์โปลินีเซีย",
        CountryCode: "+689",
      },
      {
        Id: "38fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Pap. New Guinea",
        NameTH: "ปาปัวร์นิวกินี",
        CountryCode: "+675",
      },
      {
        Id: "3afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Philippines",
        NameTH: "ฟิลิปปินส์",
        CountryCode: "+63",
      },
      {
        Id: "3cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Pakistan",
        NameTH: "ปากีสถาน",
        CountryCode: "+92",
      },
      {
        Id: "3efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Poland",
        NameTH: "โปแลนด์",
        CountryCode: "+48",
      },
      {
        Id: "40fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Puerto Rico",
        NameTH: "เปอร์โตริโก้",
        CountryCode: "+1",
      },
      {
        Id: "42fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Palestine",
        NameTH: "ปาเลสไตน์",
        CountryCode: "+970",
      },
      {
        Id: "44fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Portugal",
        NameTH: "โปรตุเกส",
        CountryCode: "+351",
      },
      {
        Id: "46fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Palau",
        NameTH: "ปาเลา",
        CountryCode: "+680",
      },
      {
        Id: "48fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Paraguay",
        NameTH: "ปารากวัย",
        CountryCode: "+595",
      },
      {
        Id: "4afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Qatar",
        NameTH: "กาตาร์",
        CountryCode: "+974",
      },
      {
        Id: "4cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Reunion",
        NameTH: "เรอูนียง",
        CountryCode: "+262",
      },
      {
        Id: "4efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Romania",
        NameTH: "โรมาเนีย",
        CountryCode: "+40",
      },
      {
        Id: "50fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Russian Fed.",
        NameTH: "เฟดรัสเซีย",
        CountryCode: "+7",
      },
      {
        Id: "52fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Rwanda",
        NameTH: "รวันดา",
        CountryCode: "+250",
      },
      {
        Id: "54fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Saudi Arabia",
        NameTH: "ซาอุดีอาระเบีย",
        CountryCode: "+966",
      },
      {
        Id: "56fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Solomon Islands",
        NameTH: "หมู่เกาะโซโลมอน",
        CountryCode: "+677",
      },
      {
        Id: "58fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Seychelles",
        NameTH: "เซเชลส์",
        CountryCode: "+248",
      },
      {
        Id: "5afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sudan",
        NameTH: "ซูดาน",
        CountryCode: "+249",
      },
      {
        Id: "5cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sweden",
        NameTH: "สวีเดน",
        CountryCode: "+46",
      },
      {
        Id: "60fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Slovenia",
        NameTH: "สโลวีเนีย",
        CountryCode: "+386",
      },
      {
        Id: "62fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Sierra Leone",
        NameTH: "เซียร์ราลีโอน",
        CountryCode: "+232",
      },
      {
        Id: "64fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Senegal",
        NameTH: "เซเนกัล",
        CountryCode: "+221",
      },
      {
        Id: "66fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Somalia",
        NameTH: "โซมาเลีย",
        CountryCode: "+252",
      },
      {
        Id: "68fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Suriname",
        NameTH: "ซูรินาม",
        CountryCode: "+597",
      },
      {
        Id: "6afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "El Salvador",
        NameTH: "เอลซัลวาดอร์",
        CountryCode: "+503",
      },
      {
        Id: "6efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Syria",
        NameTH: "ซีเรีย",
        CountryCode: "+963",
      },
      {
        Id: "70fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Togo",
        NameTH: "โตโก",
        CountryCode: "+228",
      },
      {
        Id: "74fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Turkmenistan",
        NameTH: "เติร์กเมนิสถาน",
        CountryCode: "+993",
      },
      {
        Id: "76fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tunisia",
        NameTH: "ตูนิเซีย",
        CountryCode: "+216",
      },
      {
        Id: "78fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tonga",
        NameTH: "ตองกา",
        CountryCode: "+676",
      },
      {
        Id: "7cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Turkey",
        NameTH: "ตุรกี",
        CountryCode: "+90",
      },
      {
        Id: "7efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Trinidad,Tobago",
        NameTH: "ตรินิแดดโตเบโก",
        CountryCode: "+1-868",
      },
      {
        Id: "80fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tuvalu",
        NameTH: "ตูวาลู",
        CountryCode: "+688",
      },
      {
        Id: "82fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Taiwan",
        NameTH: "ไต้หวัน",
        CountryCode: "+886",
      },
      {
        Id: "84fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Tanzania",
        NameTH: "แทนซาเนีย",
        CountryCode: "+255",
      },
      {
        Id: "86fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Ukraine",
        NameTH: "ยูเครน",
        CountryCode: "+380",
      },
      {
        Id: "88fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Uganda",
        NameTH: "ยูกันดา",
        CountryCode: "+256",
      },
      {
        Id: "8afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "United States of America",
        NameTH: "สหรัฐอเมริกา",
        CountryCode: "+1",
      },
      {
        Id: "8cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Uruguay",
        NameTH: "อุรุกวัย",
        CountryCode: "+598",
      },
      {
        Id: "8efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Uzbekistan",
        NameTH: "อุซเบกิสถาน",
        CountryCode: "+998",
      },
      {
        Id: "90fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Venezuela",
        NameTH: "เวเนซุเอลา",
        CountryCode: "+58",
      },
      {
        Id: "92fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Brit.Virgin Is.",
        NameTH: "หมู่เกาะบริตริสเวอร์จิน",
        CountryCode: "+1-284",
      },
      {
        Id: "94fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Vietnam",
        NameTH: "เวียดนาม",
        CountryCode: "+84",
      },
      {
        Id: "96fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Samoa",
        NameTH: "ซามัว",
        CountryCode: "+685",
      },
      {
        Id: "98fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Yemen",
        NameTH: "เยเมน",
        CountryCode: "+967",
      },
      {
        Id: "9afd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Mayotte",
        NameTH: "มายอต",
        CountryCode: "+262",
      },
      {
        Id: "9cfd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "South Africa",
        NameTH: "แอฟริกาใต้",
        CountryCode: "+27",
      },
      {
        Id: "9efd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Zambia",
        NameTH: "แซมเบีย",
        CountryCode: "+260",
      },
      {
        Id: "a0fd0788-ebda-ea11-a813-000d3a8543d4",
        Name: "Zimbabwe",
        NameTH: "ซิมบับเว",
        CountryCode: "+263",
      },
    ],
    CustomerProvince: [
      {
        Id: "4a0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Bangkok",
        NameTH: "กรุงเทพมหานคร",
      },
      {
        Id: "4c0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Samut Prakarn",
        NameTH: "สมุทรปราการ",
      },
      {
        Id: "4e0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nonthaburi",
        NameTH: "นนทบุรี",
      },
      {
        Id: "500c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Pathum Thani",
        NameTH: "ปทุมธานี",
      },
      {
        Id: "520c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phra Nakhon Si Ayutthaya",
        NameTH: "พระนครศรีอยุธยา",
      },
      {
        Id: "540c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Ang Thong",
        NameTH: "อ่างทอง",
      },
      {
        Id: "560c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Lop Buri",
        NameTH: "ลพบุรี",
      },
      {
        Id: "580c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Sing Buri",
        NameTH: "สิงห์บุรี",
      },
      {
        Id: "5a0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chai Nat",
        NameTH: "ชัยนาท",
      },
      {
        Id: "5c0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Saraburi",
        NameTH: "สระบุรี",
      },
      {
        Id: "5e0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chon Buri",
        NameTH: "ชลบุรี",
      },
      {
        Id: "600c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Rayong",
        NameTH: "ระยอง",
      },
      {
        Id: "620c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chanthaburi",
        NameTH: "จันทบุรี",
      },
      {
        Id: "640c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Trat",
        NameTH: "ตราด",
      },
      {
        Id: "660c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chachoengsao",
        NameTH: "ฉะเชิงเทรา",
      },
      {
        Id: "680c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Prachin Buri",
        NameTH: "ปราจีนบุรี",
      },
      {
        Id: "6a0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nakhon Nayok",
        NameTH: "นครนายก",
      },
      {
        Id: "6c0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Sa kaeo",
        NameTH: "สระแก้ว",
      },
      {
        Id: "6e0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nakhon Ratchasima",
        NameTH: "นครราชสีมา",
      },
      {
        Id: "700c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Buri Ram",
        NameTH: "บุรีรัมย์",
      },
      {
        Id: "720c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Surin",
        NameTH: "สุรินทร์",
      },
      {
        Id: "740c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Si Sa Ket",
        NameTH: "ศรีสะเกษ",
      },
      {
        Id: "760c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Ubon Ratchathani",
        NameTH: "อุบลราชธานี",
      },
      {
        Id: "780c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Yasothon",
        NameTH: "ยโสธร",
      },
      {
        Id: "7a0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chaiyaphum",
        NameTH: "ชัยภูมิ",
      },
      {
        Id: "7c0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Amnat Charoen",
        NameTH: "อำนาจเจริญ",
      },
      {
        Id: "7e0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nong Bua Lam Phu",
        NameTH: "หนองบัวลำภู",
      },
      {
        Id: "800c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Khon Kaen",
        NameTH: "ขอนแก่น",
      },
      {
        Id: "820c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Udon Thani",
        NameTH: "อุดรธานี",
      },
      {
        Id: "840c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Loei",
        NameTH: "เลย",
      },
      {
        Id: "860c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nong Khai",
        NameTH: "หนองคาย",
      },
      {
        Id: "880c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Maha Sarakham",
        NameTH: "มหาสารคาม",
      },
      {
        Id: "8a0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Roi Et",
        NameTH: "ร้อยเอ็ด",
      },
      {
        Id: "8c0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Kalasin",
        NameTH: "กาฬสินธุ์",
      },
      {
        Id: "8e0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Sakon Nakhon",
        NameTH: "สกลนคร",
      },
      {
        Id: "900c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nakhon Phanom",
        NameTH: "นครพนม",
      },
      {
        Id: "920c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Mukdahan",
        NameTH: "มุกดาหาร",
      },
      {
        Id: "940c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chiang Mai",
        NameTH: "เชียงใหม่",
      },
      {
        Id: "960c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Lamphun",
        NameTH: "ลำพูน",
      },
      {
        Id: "980c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Lampang",
        NameTH: "ลำปาง",
      },
      {
        Id: "9a0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Uttaradit",
        NameTH: "อุตรดิตถ์",
      },
      {
        Id: "9c0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phrae",
        NameTH: "แพร่",
      },
      {
        Id: "9e0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nan",
        NameTH: "น่าน",
      },
      {
        Id: "a00c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phayao",
        NameTH: "พะเยา",
      },
      {
        Id: "a20c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chiang Rai",
        NameTH: "เชียงราย",
      },
      {
        Id: "a40c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Mae Hong Son",
        NameTH: "แม่ฮ่องสอน",
      },
      {
        Id: "a60c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nakhon Sawan",
        NameTH: "นครสวรรค์",
      },
      {
        Id: "a80c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Uthai Thani",
        NameTH: "อุทัยธานี",
      },
      {
        Id: "aa0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Kamphaeng Phet",
        NameTH: "กำแพงเพชร",
      },
      {
        Id: "ac0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Tak",
        NameTH: "ตาก",
      },
      {
        Id: "ae0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Sukhothai",
        NameTH: "สุโขทัย",
      },
      {
        Id: "b00c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phitsanulok",
        NameTH: "พิษณุโลก",
      },
      {
        Id: "b20c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phichit",
        NameTH: "พิจิตร",
      },
      {
        Id: "b40c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phetchabun",
        NameTH: "เพชรบูรณ์",
      },
      {
        Id: "b60c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Ratchaburi",
        NameTH: "ราชบุรี",
      },
      {
        Id: "b80c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Kanchanaburi",
        NameTH: "กาญจนบุรี",
      },
      {
        Id: "ba0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Suphan Buri",
        NameTH: "สุพรรณบุรี",
      },
      {
        Id: "bc0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nakhon Pathom",
        NameTH: "นครปฐม",
      },
      {
        Id: "be0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Samut Sakhon",
        NameTH: "สมุทรสาคร",
      },
      {
        Id: "c00c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Samut Songkhram",
        NameTH: "สมุทรสงคราม",
      },
      {
        Id: "c20c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phetchaburi",
        NameTH: "เพชรบุรี",
      },
      {
        Id: "c40c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Prachuap Khiri Khan",
        NameTH: "ประจวบคีรีขันธ์",
      },
      {
        Id: "c60c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Nakhon Si Thammarat",
        NameTH: "นครศรีธรรมราช",
      },
      {
        Id: "c80c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Krabi",
        NameTH: "กระบี่",
      },
      {
        Id: "ca0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phang-nga",
        NameTH: "พังงา",
      },
      {
        Id: "cc0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phuket",
        NameTH: "ภูเก็ต",
      },
      {
        Id: "ce0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Surat Thani",
        NameTH: "สุราษฎร์ธานี",
      },
      {
        Id: "d00c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Ranong",
        NameTH: "ระนอง",
      },
      {
        Id: "d20c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Chumphon",
        NameTH: "ชุมพร",
      },
      {
        Id: "d40c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Songkhla",
        NameTH: "สงขลา",
      },
      {
        Id: "d60c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Satun",
        NameTH: "สตูล",
      },
      {
        Id: "d80c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Trang",
        NameTH: "ตรัง",
      },
      {
        Id: "da0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Phatthalung",
        NameTH: "พัทลุง",
      },
      {
        Id: "dc0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Pattani",
        NameTH: "ปัตตานี",
      },
      {
        Id: "de0c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Yala",
        NameTH: "ยะลา",
      },
      {
        Id: "e00c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Narathiwat",
        NameTH: "นราธิวาส",
      },
      {
        Id: "e20c2a79-4ae8-ea11-a817-000d3a8543d4",
        Name: "Bueng Kan",
        NameTH: "บึงกาฬ",
      },
    ],
    CustomerBusinessType: [
      {
        Id: "49ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Bakery shop",
      },
      {
        Id: "4bddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Beverage",
      },
      {
        Id: "4dddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Biomass plant",
      },
      {
        Id: "4fddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Building material",
      },
      {
        Id: "51ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Café",
      },
      {
        Id: "53ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Canned Food",
      },
      {
        Id: "55ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Canned Veg & Fruit",
      },
      {
        Id: "57ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Chemical",
      },
      {
        Id: "59ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Company",
      },
      {
        Id: "5bddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Components & Electronics",
      },
      {
        Id: "5dddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Construction Material",
      },
      {
        Id: "5fddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Consumer Product",
      },
      {
        Id: "61ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Conventional center",
      },
      {
        Id: "63ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Education",
      },
      {
        Id: "65ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Electronics Appliance",
      },
      {
        Id: "67ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Farmers",
      },
      {
        Id: "69ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Fertilizer and agricultural equipment agent",
      },
      {
        Id: "6bddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Food",
      },
      {
        Id: "6dddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Food producer",
      },
      {
        Id: "6fddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Fresh Veg & Flower",
      },
      {
        Id: "71ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Frozen Food",
      },
      {
        Id: "73ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Government",
      },
      {
        Id: "75ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Hotel",
      },
      {
        Id: "77ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Label producer",
      },
      {
        Id: "79ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Manufacturer",
      },
      {
        Id: "7bddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Medicine & Equipment",
      },
      {
        Id: "7dddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Milk Product",
      },
      {
        Id: "7fddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Miscellaneous",
      },
      {
        Id: "81ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Office supply / Stationery",
      },
      {
        Id: "83ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Others",
      },
      {
        Id: "85ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Packaging",
      },
      {
        Id: "87ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Packaging producer",
      },
      {
        Id: "89ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Packaging shop",
      },
      {
        Id: "8bddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Paper Converter",
      },
      {
        Id: "8dddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Paper Merchant / Agent",
      },
      {
        Id: "8fddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Paper Merchat / Agent",
      },
      {
        Id: "91ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Paper producer",
      },
      {
        Id: "93ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Petroleum Product",
      },
      {
        Id: "95ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Power plant",
      },
      {
        Id: "97ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Printing House",
      },
      {
        Id: "99ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Restaurant",
      },
      {
        Id: "9bddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Rubber,Toy,Shoes",
      },
      {
        Id: "9dddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Supplier",
      },
      {
        Id: "9fddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Textile producer",
      },
      {
        Id: "a1ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Textile,Garment",
      },
      {
        Id: "a3ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Tobacco",
      },
      {
        Id: "a5ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Trader",
      },
      {
        Id: "a7ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Vehicle Components",
      },
      {
        Id: "a9ddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Wood chip export/import",
      },
      {
        Id: "abddad10-72ca-ea11-a812-000d3a8524ff",
        Name: "Wood chip plant",
      },
    ],
  };
}
